import { IPROP_MAP, modifyProps } from '../../generators/modifyProps';

import { JDSSpinnerProps } from './generated';

export interface SpinnerProps extends Omit<JDSSpinnerProps, 'value'> {
  /**
   * Determines the appearance of the spinner
   * `inline`   inherit from text color
   * `normal`   single color
   * `vibrant`  three color
   *
   * @deprecated
   * use `kind`
   */
  appearance?: 'normal' | 'vibrant' | 'inline';
}

export const PROP_MAP: IPROP_MAP<SpinnerProps> = (props) => ({
  appearance: {
    properties: {
      kind: props.appearance
    }
  }
});

export const withLogic =
  (Component: React.ComponentType<SpinnerProps>): React.FC<SpinnerProps> =>
  (userProps: SpinnerProps) => {
    const props = modifyProps(userProps, PROP_MAP);
    return (
      <Component
        appearance={props.appearance || 'normal'}
        {...{ ...props, _determinate: props.value !== undefined }}
      />
    );
  };
